import React from "react";

type PullQuoteProps = {
  children: React.ReactNode;
};

export function PullQuote({ children }: PullQuoteProps) {
  return (
    <blockquote className="my-10 border-l-4 border-[var(--accent)] pl-6 text-left">
      <p className="text-base md:text-lg font-sans font-semibold italic text-[var(--ink)] leading-relaxed">
        {children}
      </p>
    </blockquote>
  );
}
